<template lang="pug">
section
  s-page-title(title='Инфраструктура')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(:initial='dataFilter.search' @search='debouncedSearch')
      template(slot='controls')
        v-layout
          v-flex(xs12)
            s-sites-picker(
              @change='setSiteId'
              :value='dataFilter.site_id'
              :returnObject='false'
              label='Выберите сайт'
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='mergedList'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)' )
          td {{ props.item.id }}
          td
            v-chip(
              :key="props.item.site.name"
              :color="props.item.site.color"
              text-color="white"
              small
            ) {{ props.item.site.name }}
          td
            template()
              v-img(
                :aspect-ratio='16/9'
                :lazy-src='props.item.icon_url'
                :src='props.item.icon_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
          td 
            template()
              div {{ props.item.name }}
              div(class='comment') Тип: {{ props.item.mark_kind }} 
                span(v-if='props.item.width') &nbsp;Размер: {{ props.item.width +'x' + props.item.height }}
                span(v-if='props.item.offcet_x') &nbsp;Смещение: {{ props.item.offcet_x +'x' + props.item.offcet_y }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Сайт',
        align: 'center',
        sortable: true,
        value: 'site_id',
        width: '15%'
      },
      {
        text: 'Иконка',
        align: 'center',
        sortable: false,
        width: '15%'
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '100%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetch()
  },

  methods: {
    onEdit({ id } = {}) {
      this.$router.push({
        name: 'InfrastructureDictionary.Edit',
        params: { id }
      })
    },

    updatePagination(pagination) {
      this.setDataFilter({
        ...pagination,
        // Выводим все строки
        // ибо нет пагинации
        rowsPerPage: -1
      })
    },

    setSiteId(site_id = null) {
      this.setDataFilter({ site_id })
      this.fetch()
    },

    getSite(id) {
      const site = this.sitesById(id)
      if (!site) return {}
      return { color: site.color, name: site.name }
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search })
      this.fetch()
    }, 250),

    ...mapActions('dictionaries/infrastructure', ['fetchList', 'destroy']),
    ...mapMutations('dictionaries/infrastructure', ['setDataFilter'])
  },

  computed: {
    ...mapGetters({ sitesById: 'dictionary/sites/byId' }),
    ...mapState('dictionaries/infrastructure', ['total', 'dataFilter']),
    ...mapGetters('dictionaries/infrastructure', ['list', 'isLoading']),

    mergedList() {
      return this.list.map(l => ({ ...l, site: this.getSite(l.site_id) }))
    }
  }
}
</script>

<style scoped>
.comment {
  color: #afafaf;
}
</style>
